// extracted by mini-css-extract-plugin
export default {"cookiePolicyPage":"CookiePolicyPage-module--cookiePolicyPage--Hcc2y","container":"CookiePolicyPage-module--container--uCT-x","header":"CookiePolicyPage-module--header--lJVXi"};